import cn from 'classnames';
import Tag from '../tag';
import type { ComponentChildren } from 'preact';
import type { HTMLAttributes } from '../../types/utility';

export type HeadingLevel = 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';

type Props = HTMLAttributes<HTMLHeadingElement> & {
  level: HeadingLevel;
  visualLevel?: HeadingLevel;
  children: ComponentChildren;
  isVisuallyHidden?: boolean;
};

export default function Heading({
  level: Heading,
  visualLevel,
  children,
  className,
  isVisuallyHidden = false,
  ...headingProps
}: Props) {
  const classList =
    cn(className, {
      [`visual-${visualLevel}`]: visualLevel,
      'visually-hidden': isVisuallyHidden,
    }) || undefined;

  return (
    <Heading className={classList} {...headingProps}>
      {children}
    </Heading>
  );
}

export function TaggedHeading({ children, className, tag, ...props }: Props & { tag: string }) {
  const classList = cn('tagged-heading', className);
  return (
    <Heading className={classList} {...props}>
      {children} <Tag>{tag}</Tag>
    </Heading>
  );
}
